module.exports = __webpack_public_path__ + "img/宣传_04.407e0946.jpg";